/* Eloura Living */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EL = window.EL || {};

  var esc = function (s) { var t = d.createElement('div'); t.textContent = s == null ? '' : String(s); return t.innerHTML.replace(/'/g, '&#39;'); };
  var money = function (cents) {
    var v = (Number(cents) || 0) / 100;
    var f = EL.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
      return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }).replace(/<[^>]*>/g, '');
  };
  var imgUrl = function (u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };

  /* Smooth scrolling */
  var lenis = null;
  if (!reduce && window.Lenis) {
    lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true });
    var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  }
  var lock = function (on) {
    d.documentElement.classList.toggle('is-locked', on);
    if (lenis) { if (on) lenis.stop(); else lenis.start(); }
  };

  /* Overlays (menu, search, cart) */
  var drawer = d.getElementById('CartDrawer');
  var openO = function (el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock(true);
    var f = $('[data-autofocus]', el);
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
  };
  var closeO = function (el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.overlay.is-open')) lock(false);
  };
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open],[data-close]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-open')) {
      var id = t.getAttribute('data-open');
      $$('.overlay.is-open').forEach(closeO);
      if (id === 'CartDrawer') openCart(); else openO(d.getElementById(id));
    } else {
      closeO(t.closest('.overlay'));
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.overlay.is-open').forEach(closeO); });

  /* Header, parallax */
  var header = $('[data-header]');
  var px = $$('[data-parallax]');
  var lastY = window.scrollY;
  var ticking = false;
  var measure = function () {
    px.forEach(function (el) {
      el.style.setProperty('--py', '0px');
      var r = el.getBoundingClientRect();
      el._top = r.top + window.scrollY;
      el._h = r.height;
    });
  };
  var onScroll = function () {
    var y = window.scrollY;
    if (header) {
      header.classList.toggle('is-scrolled', y > 8);
      if (Math.abs(y - lastY) > 4) header.classList.toggle('is-hidden', y > lastY && y > 480 && !d.documentElement.classList.contains('is-locked'));
    }
    lastY = y;
    if (!reduce) {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        if (el._top == null) return;
        var top = el._top - y;
        if (top + el._h < -200 || top > vh + 200) return;
        var c = top + el._h / 2 - vh / 2;
        el.style.setProperty('--py', (c * -parseFloat(el.getAttribute('data-parallax') || 0)).toFixed(1) + 'px');
      });
    }
    ticking = false;
  };
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); });
  window.addEventListener('load', function () { measure(); onScroll(); });
  measure(); onScroll();

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Toast */
  var toast = function (msg) {
    var t = $('.toast');
    if (!t) { t = d.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  };

  /* Cart */
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var getCart = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
  var renderCart = function (cart) {
    $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    drawer.classList.toggle('is-empty', !cart.item_count);
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    $('[data-cart-label]', drawer).textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var body = $('[data-cart-items]', drawer);
    if (!cart.items.length) {
      body.innerHTML = `<div class='drawer__empty'><h3>Your bag is empty</h3><p>Let us help you find something beautiful.</p><a class='btn' href='/collections/all'>Shop the collection</a></div>`;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var variant = it.product_has_only_default_variant ? '' : `<p class='line-item__variant'>${esc(it.variant_title)}</p>`;
      return `<div class='line-item' style='--d:${i * 70}ms'>
        <a href='${it.url}'><img src='${imgUrl(it.image, 240)}' alt='' loading='lazy'></a>
        <div><a class='line-item__title' href='${it.url}'>${esc(it.product_title)}</a>${variant}
          <div class='qty-mini'><button type='button' data-line='${i + 1}' data-q='${it.quantity - 1}' aria-label='Decrease quantity'>&minus;</button><span>${it.quantity}</span><button type='button' data-line='${i + 1}' data-q='${it.quantity + 1}' aria-label='Increase quantity'>+</button></div>
        </div>
        <div class='line-item__end'><p>${money(it.final_line_price)}</p><button type='button' class='line-item__remove' data-line='${i + 1}' data-q='0'>Remove</button></div>
      </div>`;
    }).join('');
  };
  var openCart = function () {
    if (!drawer) { window.location.href = '/cart'; return; }
    openO(drawer);
    drawer.classList.add('is-loading');
    getCart().then(function (c) { renderCart(c); }).finally(function () { drawer.classList.remove('is-loading'); });
  };
  var bump = function () { $$('[data-cart-count]').forEach(function (n) { n.classList.remove('bump'); void n.offsetWidth; n.classList.add('bump'); }); };
  var addToCart = function (items, btn) {
    if (btn) btn.classList.add('is-busy');
    return fetch('/cart/add.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'Sorry, that could not be added.'); return; }
        return getCart().then(function (c) { renderCart(c); $$('.overlay.is-open').forEach(closeO); openO(drawer); bump(); });
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () { if (btn) btn.classList.remove('is-busy'); });
  };
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b) return;
      drawer.classList.add('is-loading');
      fetch('/cart/change.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ line: +b.getAttribute('data-line'), quantity: +b.getAttribute('data-q') }) })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .finally(function () { drawer.classList.remove('is-loading'); });
    });
  }
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    addToCart([{ id: +q.getAttribute('data-quick-add'), quantity: 1 }], q);
  });

  /* Quantity steppers */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var i = $('input', b.parentElement);
    if (!i) return;
    var min = i.min !== '' ? +i.min : 1;
    i.value = Math.max(min, (+i.value || 0) + (+b.getAttribute('data-qty')));
    i.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form */
  var pf = d.getElementById('ProductForm');
  if (pf) {
    var addBtn = $('[name=add]', pf);
    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(pf);
      addToCart([{ id: +fd.get('id'), quantity: Math.max(1, +fd.get('quantity') || 1) }], addBtn);
    });
    var sel = $('select[name=id]', pf);
    var priceEl = $('[data-price]');
    if (sel && priceEl) sel.addEventListener('change', function () { var o = sel.options[sel.selectedIndex]; if (o && o.getAttribute('data-price')) priceEl.textContent = money(o.getAttribute('data-price')); });
    var sa = $('[data-sticky-atc]');
    if (sa && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var en = es[0]; sa.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); }).observe(addBtn);
      $('button', sa).addEventListener('click', function () { if (pf.requestSubmit) pf.requestSubmit(); else addBtn.click(); });
    }
  }

  /* Product gallery */
  var track = $('[data-gallery-track]');
  if (track) {
    var slides = $$('.pdp__slide', track);
    var navs = $$('[data-thumb]');
    var setActive = function (i) { navs.forEach(function (n) { n.classList.toggle('is-active', +n.getAttribute('data-thumb') === i); }); };
    navs.forEach(function (n) {
      n.addEventListener('click', function () {
        var s = slides[+n.getAttribute('data-thumb')];
        if (s) track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if ('IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) setActive(slides.indexOf(en.target)); }); }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { so.observe(s); });
    }
    if (window.matchMedia('(hover: hover)').matches) {
      slides.forEach(function (s) {
        var im = $('img', s);
        if (!im) return;
        s.addEventListener('click', function () { s.classList.toggle('is-zoom'); });
        s.addEventListener('mousemove', function (e) { var r = s.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
      });
    }
  }

  /* Rails: arrows, progress, drag */
  $$('[data-rail]').forEach(function (w) {
    var r = $('.rail', w);
    if (!r) return;
    var prev = $('[data-prev]', w), next = $('[data-next]', w), bar = $('.rail-progress span', w);
    var step = function () { var c = r.firstElementChild; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(r).columnGap) || 0) : r.clientWidth * 0.8; };
    var upd = function () {
      var max = r.scrollWidth - r.clientWidth;
      var vis = r.scrollWidth ? r.clientWidth / r.scrollWidth : 1;
      var p = max > 0 ? r.scrollLeft / max : 0;
      if (bar) bar.style.transform = 'scaleX(' + Math.min(1, vis + (1 - vis) * p) + ')';
      if (prev) prev.disabled = r.scrollLeft < 4;
      if (next) next.disabled = r.scrollLeft > max - 4;
    };
    if (prev) prev.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: 'smooth' }); });
    r.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    var down = false, moved = false, sx = 0, sl = 0;
    r.addEventListener('dragstart', function (e) { e.preventDefault(); });
    r.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = r.scrollLeft; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; r.classList.add('is-dragging'); }
      if (moved) r.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        var s = step();
        var target = Math.round(r.scrollLeft / s) * s;
        r.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(function () { r.classList.remove('is-dragging'); }, 450);
      }
    });
    r.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* Accordions with smooth height */
  $$('[data-acc] details').forEach(function (det) {
    var sum = $('summary', det);
    if (!sum) return;
    var body = $('.acc__body', det);
    if (!body) {
      body = d.createElement('div');
      body.className = 'acc__body';
      while (sum.nextSibling) body.appendChild(sum.nextSibling);
      det.appendChild(body);
    }
    sum.addEventListener('click', function (e) {
      if (reduce || !body.animate) return;
      e.preventDefault();
      if (det.open) {
        var h = body.offsetHeight;
        var a = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.4,0,.2,1)' });
        a.onfinish = function () { det.open = false; };
      } else {
        det.open = true;
        var h2 = body.offsetHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 520, easing: 'cubic-bezier(.16,1,.3,1)' });
      }
    });
  });

  /* Predictive search */
  var si = $('[data-search-input]'), sr = $('[data-search-results]'), st;
  if (si && sr) {
    si.addEventListener('input', function () {
      clearTimeout(st);
      var q = si.value.trim();
      if (q.length < 2) { sr.innerHTML = ''; return; }
      st = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            sr.innerHTML = ps.length ? ps.map(function (p) {
              var im = p.image ? `<img src='${imgUrl(p.image, 200)}' alt=''>` : '';
              return `<a class='sr' href='${p.url}'>${im}<span><strong>${esc(p.title)}</strong><em>${money(Math.round(parseFloat(p.price) * 100))}</em></span></a>`;
            }).join('') : `<p class='search__hint'>No pieces found for &ldquo;${esc(q)}&rdquo;.</p>`;
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* Sorting */
  var go = function (href) {
    if (reduce) { window.location.href = href; return; }
    d.body.classList.add('is-leaving');
    setTimeout(function () { window.location.href = href; }, 300);
  };
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      go(u.href);
    });
  });

  /* In-page anchors with smooth scroll */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^=\'#\']');
    if (!a || e.defaultPrevented) return;
    var id = a.getAttribute('href');
    if (id.length < 2) return;
    var target = d.getElementById(id.slice(1));
    if (!target) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(target, { offset: -90 });
    else target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* Page transitions */
  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target || a.hasAttribute('download') || a.hasAttribute('data-no-transition')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    var u = new URL(a.href, window.location.href);
    if (u.origin !== window.location.origin) return;
    if (u.pathname === window.location.pathname && u.search === window.location.search) return;
    e.preventDefault();
    go(u.href);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) d.body.classList.remove('is-leaving'); });
})();
